import { render, staticRenderFns } from "./hiPublishDialog.vue?vue&type=template&id=1b059e37&"
import script from "./hiPublishDialog.vue?vue&type=script&lang=js&"
export * from "./hiPublishDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports